// import React, { useEffect, useState } from "react";
// import "./style.css";

// function TodoList({ name, value, onChange }) {
//   const [lines, setLines] = useState([""]);
//   const [isFocused, setIsFocused] = useState(false);

//   useEffect(() => {
//     if (value && value.length > 0) {
//       const result = value.map((line) => "• " + line.trim());
//       setLines(result);
//     } else {
//       setLines([""]);
//     }
//   }, [value]);

//   const handleFocus = () => {
//     setIsFocused(true);
//     if (lines.length === 0 || lines[0] === "") {
//       setLines(["• "]);
//     }
//   };

//   const handleBlur = () => {
//     onChange(lines, name);
//     setIsFocused(false);
//   };

//   const handleKeyUp = (event) => {
//     if (event.key === "Enter") {
//       event.preventDefault();
//       const updatedLines = [...lines, "• "];
//       setLines(updatedLines);
//     }
//   };

//   const handleChange = (event) => {
//     const updatedLines = event.target.value
//       .split("\n")
//       .filter((line) => line.trim() !== "");
//     setLines(updatedLines);
//   };

//   const calculateHeight = () => {
//     const lineHeight = 100;
//     return `${lines.length * lineHeight}px`;
//   };

//   return (
//     <textarea
//       className={`todolist ${isFocused ? "focused" : ""}`}
//       name="menu"
//       style={{
//         height: calculateHeight(),
//         padding: "8px",
//         borderRadius: "8px",
//         border: `1px solid ${isFocused ? "#3faac3" : "#d4d4d4"}`,
//         borderWidth: isFocused ? "2px" : "1px",
//         fontFamily: "Poppins",
//         outline: "none",
//       }}
//       placeholder="Enter menu details"
//       value={lines.join("\n")}
//       onFocus={handleFocus}
//       onBlur={handleBlur}
//       onKeyUp={handleKeyUp}
//       onChange={handleChange}
//     />
//   );
// }

// export default TodoList;

import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
  useRef,
} from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // Import Quill styles
import './style.css';

const TodoList = forwardRef(({ name, value, onChange, type }, ref) => {
  const [text, setText] = useState('');
  const [content, setContent] = useState('');
  const isUserInput = useRef(false);
  const timeoutRef = useRef(null);

  useEffect(() => {
    // Only update if the change is not from user input
    if (!isUserInput.current && value && Array.isArray(value) && value.length !== 0) {
      const htmlContent = convertDataToHTML(value);
      setText(htmlContent);
      setContent(htmlContent);
    } else if (!isUserInput.current && (!value || !Array.isArray(value) || value.length === 0)) {
      // Initialize with empty content if no value or empty array
      setText('');
      setContent('');
    }
    // Reset the flag
    isUserInput.current = false;
  }, [value]);

  // Cleanup timeout on unmount
  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  function convertDataToHTML(data) {
    let textConversion = '';

    if (!Array.isArray(data) || data.length === 0) {
      return '';
    }

    data.forEach((item) => {
      if (item && item.title && item.title.trim() !== "") {
        textConversion += `<p>${item.title}</p>`;
      }
      if (item && item.list && Array.isArray(item.list)) {
        textConversion += `<ul>`;
        item.list.forEach((listItem) => {
          if (listItem && listItem.trim() !== '') {
            textConversion += `<li>${listItem}</li>`;
          }
        });
        textConversion += `</ul>`;
      }
    });
    return textConversion;
  }

  const handleChange = (content) => {
    if (content) {
      // Set flag to indicate this is user input
      isUserInput.current = true;
      
      setContent(content);
      function convertText(text) {
        const regex = /<p>(.*?)<\/p>/g; // Matches all occurrences of <p> with content inside
        return text.replace(regex, function (match, content) {
          return `<p><strong>${content}</strong></p>`;
        });
      }

      const transformedText = convertText(content);
      setText(transformedText);

      // Clear existing timeout
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      // Debounce the onChange call to prevent excessive updates
      timeoutRef.current = setTimeout(() => {
        const parsedData = parseContentToStructure(content);
        onChange(parsedData, name);
      }, 300); // 300ms debounce
    }
  };

  const parseContentToStructure = (content) => {
    if (!content || typeof content !== 'string') return [];
    
    try {
      const parser = new DOMParser();
      const doc = parser.parseFromString(content, 'text/html');
      const sections = doc.body.children;
      const result = [];
      let currentSection = { title: '', list: [] };

      for (let i = 0; i < sections.length; i++) {
        const section = sections[i];
        if (section.tagName === 'P' && section.textContent && section.textContent.trim() !== '') {
          // Process the <p> tag
          if (currentSection.list.length > 0 || currentSection.title !== '') {
            result.push(currentSection);
          }
          const title = section.textContent.trim();
          currentSection = { title, list: [] };
        } else if (section.tagName === 'UL') {
          // Process the <ul> tag
          const listItems = Array.from(section.children)
            .map((li) => li.textContent ? li.textContent.trim() : '')
            .filter((li) => li !== ''); // Remove empty list items
          if (
            currentSection.list.length > 0 ||
            currentSection.title !== '' ||
            listItems.length > 0
          ) {
            currentSection.list.push(...listItems);
          }
        } else if (section.tagName === 'P' && section.innerHTML === '<br>') {
          // Ignore <p><br></p>
          continue;
        }
      }

      if (currentSection.list.length > 0 || currentSection.title !== '') {
        result.push(currentSection);
      }

      return result;
    } catch (error) {
      console.error('Error parsing content:', error);
      return [];
    }
  };

  const handleFoodMenu = () => {
    if (!Array.isArray(text)) {
      let value = text.replace(
        /^(<p><strong><br><\/strong><\/p>)+|(<p><strong><br><\/strong><\/p>)+$/g,
        ''
      );
      setText(value);
      return parseContentToStructure(value);
    } else {
      return value;
    }
  };

  useImperativeHandle(ref, () => ({
    handleFoodMenu,
  }));

  return (
    <div>
      <ReactQuill
        value={content || ''}
        onChange={handleChange}
        placeholder={`Enter ${type} details`}
        modules={{
          toolbar: [[{ list: 'bullet' }]],
        }}
      />
    </div>
  );
});

export default TodoList;
